import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import AllRoutes from './Routes';

function AuthenticatedRoutes() {
	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<AllRoutes />
		</LocalizationProvider>
	);
}

export default AuthenticatedRoutes;